import React, { Component } from 'react';
import { genClassName } from '../../../utils/helpers';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {string} src - src	attr
 * @prop {string} alt - alt attr
 * @prop {string} [className] - CSS class name
 *
 * @augments {Component<Props>}
 */
export default class BlueIconWrapper extends Component {

	render () {
		const { className, src, alt } = this.props;
		return (
			<picture className={genClassName('BlueIconWrapper', className)}>
				<img src={require(`../../../assets/svg/${src}`)} alt={alt} />
			</picture>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/atoms/BlueIconWrapper/BlueIconWrapper.js